module.exports = __webpack_public_path__ + "assets/img/dayu_zxwz.53d0c765.png";